export const TRANSLATIONS = ['KJV', 'ESV', 'NIV', 'NASB', 'NLT', 'NKJV'] as const
